var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18297 3.28569C3.6026 3.04865 3.04865 3.6026 3.28569 4.18297L5.00961 8.40384C5.10782 8.6443 5.07125 8.91316 4.91389 9.10748L2.1518 12.5183C1.77201 12.9873 2.1523 13.7099 2.76779 13.6888L7.24404 13.5354C7.49906 13.5266 7.74531 13.6562 7.88853 13.8745L10.4023 17.7065C10.748 18.2333 11.537 18.126 11.6803 17.5326L12.612 13.6758L20.716 21.7797C21.0097 22.0734 21.486 22.0734 21.7797 21.7797C22.0734 21.486 22.0734 21.0097 21.7797 20.716L13.6758 12.612L17.5326 11.6803C18.126 11.537 18.2334 10.748 17.7065 10.4023L13.8745 7.88853C13.6562 7.74531 13.5266 7.49906 13.5354 7.24404L13.6888 2.76779C13.7099 2.1523 12.9873 1.77201 12.5183 2.1518L9.10748 4.91389C8.91316 5.07125 8.64431 5.10782 8.40384 5.00961L4.18297 3.28569Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWand);
export default __webpack_public_path__ + "static/media/wand.b87f2071bb624a4bd3900dd6279bea91.svg";
export { ForwardRef as ReactComponent };